import { render, staticRenderFns } from "./couponOrderDetail.vue?vue&type=template&id=47778e89&scoped=true"
import script from "./couponOrderDetail.vue?vue&type=script&lang=js"
export * from "./couponOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./couponOrderDetail.vue?vue&type=style&index=0&id=47778e89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47778e89",
  null
  
)

export default component.exports